export default __webpack_public_path__ + "static/media/deleteRed.8760bcbc.svg";